/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "PipefyIntegration",
            "endpoint": "https://z1dmoabiwb.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://4d6icbogpzfrrpmeaaqcybawfe.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-f6cahicmena7tj43grt5zsgcgy",
    "aws_cognito_identity_pool_id": "us-east-1:f6812940-858b-4b4d-9b6a-13747d91de8b",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_HzohDCg3k",
    "aws_user_pools_web_client_id": "mk8f6mdlhha6gh83bvv4vd92b",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "portal-parceiro-frontend-storage173420-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
